export class DelayLoading {
    private _val: boolean = false;
    private t: any;

    get val(){
        return this._val;
    }

    set val(data:boolean){
        if(this.t){
            clearTimeout(this.t);
        }
        if(!data){
            this._val = false;
        }else{
            this.t = setTimeout(()=>{
                this._val = data;
                clearTimeout(this.t);
            },1000);
        }
    }

    setImmediate(){
        this._val = true;
    }
}

export class MinLoadingTime {
    private _val: boolean = false;
    private t: any;

    get val(){
        return this._val;
    }

    set val(data: boolean){
        if(this._val && !data && !this.t){
            this.t = setTimeout(()=>{
                this._val = false;
                clearTimeout(this.t);
                this.t = null;
            }, 300);
        }

        if(this._val && !data && this.t){
            return
        }

        this._val = data;
    }
}
